"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_ChartRow = exports.bpfrpt_proptype_ChartScalar = exports.bpfrpt_proptype_ChartColumnList = exports.bpfrpt_proptype_ChartColumn = exports.bpfrpt_proptype_ChartColumnInputList = exports.bpfrpt_proptype_ChartColumnInput = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var bpfrpt_proptype_ChartColumnInput = {
  key: function key() {
    return (typeof $Keys === "function" ? _propTypes.default.instanceOf($Keys).isRequired : _propTypes.default.any.isRequired).apply(this, arguments);
  },
  label: _propTypes.default.string,
  isContinuous: _propTypes.default.bool
};
exports.bpfrpt_proptype_ChartColumnInput = bpfrpt_proptype_ChartColumnInput;

var bpfrpt_proptype_ChartColumnInputList = _propTypes.default.arrayOf(_propTypes.default.shape({
  key: function key() {
    return (typeof $Keys === "function" ? _propTypes.default.instanceOf($Keys).isRequired : _propTypes.default.any.isRequired).apply(this, arguments);
  },
  label: _propTypes.default.string,
  isContinuous: _propTypes.default.bool
}).isRequired);

exports.bpfrpt_proptype_ChartColumnInputList = bpfrpt_proptype_ChartColumnInputList;
var bpfrpt_proptype_ChartColumn = {
  key: function key() {
    return (typeof $Keys === "function" ? _propTypes.default.instanceOf($Keys).isRequired : _propTypes.default.any.isRequired).apply(this, arguments);
  },
  label: _propTypes.default.string.isRequired,
  isContinuous: _propTypes.default.bool.isRequired
};
exports.bpfrpt_proptype_ChartColumn = bpfrpt_proptype_ChartColumn;

var bpfrpt_proptype_ChartColumnList = _propTypes.default.arrayOf(_propTypes.default.shape({
  key: function key() {
    return (typeof $Keys === "function" ? _propTypes.default.instanceOf($Keys).isRequired : _propTypes.default.any.isRequired).apply(this, arguments);
  },
  label: _propTypes.default.string.isRequired,
  isContinuous: _propTypes.default.bool.isRequired
}).isRequired);

exports.bpfrpt_proptype_ChartColumnList = bpfrpt_proptype_ChartColumnList;

var bpfrpt_proptype_ChartScalar = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, function () {
  return (typeof Date === "function" ? _propTypes.default.instanceOf(Date) : _propTypes.default.any).apply(this, arguments);
}]);

exports.bpfrpt_proptype_ChartScalar = bpfrpt_proptype_ChartScalar;

var bpfrpt_proptype_ChartRow = _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, function () {
  return (typeof Date === "function" ? _propTypes.default.instanceOf(Date) : _propTypes.default.any).apply(this, arguments);
}]));

exports.bpfrpt_proptype_ChartRow = bpfrpt_proptype_ChartRow;